import { Component, Input, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-invalid-federation',
  standalone: false,
  template: `
    <div class="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-6">
      <div class="bg-white rounded-2xl shadow-lg p-8 w-full max-w-md text-center">

        <div class="flex items-center justify-center w-16 h-16 bg-red-100 rounded-full mx-auto mb-6">
          <span class="text-3xl">✗</span>
        </div>

        <h1 class="text-xl font-bold text-gray-800">Fédération introuvable</h1>
        <p class="mt-2 text-sm text-gray-500">
          Le code <span class="font-semibold text-red-600 uppercase">{{ slug }}</span>
          ne correspond à aucune fédération enregistrée sur SportIQ.
        </p>
        <p class="mt-1 text-xs text-gray-400">Vérifiez l'URL ou contactez le support SportIQ.</p>

        <button
          (click)="goToSelector()"
          class="mt-8 w-full bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium py-2.5 rounded-lg transition-colors"
        >
          ← Choisir ma fédération
        </button>

      </div>
    </div>
  `,
})
export class InvalidFederationComponent implements OnInit {
  @Input() slug: string | null = null;

  mainUrl = '';

  ngOnInit(): void {
    const { protocol } = window.location;
    const baseDomain = (environment as any).baseDomain;
    this.mainUrl = `${protocol}//${baseDomain}`;
  }

  goToSelector(): void {
    window.location.href = this.mainUrl;
  }
}
